export default {"src":"https://dap-rfjepjn8u-dap-rewrite.vercel.app/_next/static/media/icon-marker.67e1b489.svg","height":28,"width":22};